import { X } from "lucide-react";

/**
 * FilterChip — active-filter pill row above the products table. One chip per
 * engaged filter with an X button to clear that dimension. Used with the
 * PresenceFilterPopover, CategoryTreeFilter and MultiSelectFilterPopover.
 */
export const FilterChip = ({ label, onClear, testId, title }) => (
    <span
        className="inline-flex items-center gap-1.5 h-6 px-2 rounded-md border border-border bg-surface text-[11px] text-foreground/90"
        data-testid={testId}
        title={title || label}
    >
        {label}
        <button
            onClick={onClear}
            className="text-muted-foreground/70 hover:text-destructive transition-colors"
            aria-label={`${label} filtresini kaldır`}
        >
            <X className="h-3 w-3" />
        </button>
    </span>
);

/**
 * QuickFilter — small text-only toggle used on the Tables view toolbar
 * ("Aktif", "Pasif", "Bağlı", "Bağsız"). Not the primary filter surface —
 * secondary shortcuts that layer on top of MultiSelectFilterPopover state.
 */
export const QuickFilter = ({ active, onClick, children, accent, testId }) => (
    <button
        onClick={onClick}
        data-testid={testId}
        className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-[11.5px] font-medium transition-colors ${
            active
                ? accent === "success" ? "bg-success-soft text-success" : accent === "warning" ? "bg-warning-soft text-warning" : "bg-muted text-foreground"
                : "text-muted-foreground hover:text-foreground hover:bg-muted/60"
        }`}
    >
        {children}
    </button>
);
